export default "__VITE_ASSET__BXTplT34__"